import React, { useCallback, useEffect, useState } from 'react';
import { List, Spin, Typography } from 'antd';
import { AssigneeModel } from '@/typings/models/Assignee';
import { fetchLeads as fetchLeadsRequest } from '@/services/api/lead';
import { SKIP_TOTAL_SIZE } from '@/utils/pagination';
import { LeadActionTag } from '@/components/ActionTag';
import { processAPIResponseNow } from '@/utils/request';
import { LeadStatePresentation } from '@/components/Filters/LeadStateFilters';
import { LeadProductGroupPresentation } from '@/components/Lead/LeadProductGroup';
import { LeadModel } from '@/typings/models/Lead';

const { Text } = Typography;

interface AgentProjectsTabProps {
  agent: AssigneeModel;
}

const AgentProjectsTab: React.FC<AgentProjectsTabProps> = ({ agent }) => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLeads = useCallback(() => {
    if (!agent?.id) return;

    setLoading(true);
    fetchLeadsRequest({
      query: {
        assignee: agent.id,
        page_size: 50,
        ...SKIP_TOTAL_SIZE,
      }
    }).then(Response => {
      processAPIResponseNow(Response, {
        onSuccess(data){
          setLeads(data || []);
        },
        onEnd(){
          setLoading(false)
        }
      }, 'data')
    });
  }, [agent?.id]);

  useEffect(() => {
    fetchLeads();
  }, [fetchLeads]);

  return (
      <Spin spinning={loading}>
        <List
          itemLayout="horizontal"
          dataSource={leads}
          size={"small"}
          renderItem={(lead: LeadModel) => (
            <List.Item actions={[
                <LeadStatePresentation key={'state'} state={lead.lead_state}/>,
                lead.product_group ? <LeadProductGroupPresentation lead={lead} /> : null
            ].filter(Boolean)}>
              <List.Item.Meta title={<LeadActionTag key="view" lead={lead} size="large" />} />
            </List.Item>
          )}
        />
      </Spin>
  );
};

export default AgentProjectsTab;
